/**
 *  Created by piotr@revisual.io on 01/02/2026
 */
import classNames from "classnames";
import { useMemo } from "react";

export const CardTags = ({
  event,
  showAsPills,
  numberOfTags = undefined,
  showTagsAsPills,
  rejectedTags = [],

  showTagSign,
}) => {
  const tags = useMemo(
    () =>
      event?.tags
        ?.filter((i) => !rejectedTags.find((j) => i.label.endsWith(j)))
        .slice(0, numberOfTags === "all" ? undefined : numberOfTags)
        .map((i) => (
          <li
            key={i.label}
            className={classNames("card-view--card-content-tags-tag", {
              "card-view--card-content-tags-tag_border": showAsPills,
            })}
          >
            {showTagSign ? (
              <span className={"card-view--card-content-tags-tag-sign"}>#</span>
            ) : null}
            {i.label.slice(1, undefined)}
          </li>
        )),
    [
      event,
      numberOfTags,
      showAsPills,
      showTagsAsPills,
      rejectedTags,
      showTagSign,
    ]
  );

  return (
    <ul className={"card-view--card-content-tags"} role="list">
      {tags}
    </ul>
  );
};

export default CardTags;
